import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { PharmacyTokenService } from './pharmacy-token.service';

@Injectable({
  providedIn: 'root',
})

export class PharmacyAuthStateService {
  private userState = new BehaviorSubject<boolean>(this.token.isLoggedIn()!);
  userAuthState = this.userState.asObservable();
  constructor(public token: PharmacyTokenService) {}
  setAuthState(value: boolean) {
    this.userState.next(value);
  }
}